import data from "../../../../../src/PageHeader/PageHeader.docs.json";
import * as React from 'react';
export default {
  data,
  React
};